import { WidgetLineGraph } from '../Widgets';
import { connect } from 'react-redux';
import { getSubsData, fetchActiveSubData } from '../../redux/actions/subs';
import { sumByField, formatDateFromRange, calculateGrowth } from '../../helpers';

const mapStateToProps = (state, ownProps) => ({
  id: 'WidgetSubs',
  className: ownProps.className,
  width: ownProps.width,
  height: ownProps.height,
  graph: state.subs.WidgetSubs
    && state.subs.WidgetSubs.data
    && state.filter.filters.endDate
    && state.filter.filters.startDate ? [state.subs.WidgetSubs.data.map(item => ({ key: formatDateFromRange(item.dt, state.filter.filters), value: item.ns, dt: item.dt
  }))] : [],
  exportData: state.subs.WidgetSubs && state.subs.WidgetSubs.data && state.filter.filters.endDate && state.filter.filters.startDate ? state.subs.WidgetSubs.data.map(item => ({ dt: item.dt, "Subscribers": item.ns})) : [],
  info: state.subs.WidgetSubs && state.subs.WidgetSubs.activeSubs ? [{
    amount: sumByField(state.subs.WidgetSubs.data, 'ns'),
    description: "New Subs (Total)"
  }, {
    amount: state.subs.WidgetSubs.activeSubs.length > 1 ? state.subs.WidgetSubs.activeSubs[1].ns: (state.subs.WidgetSubs.activeSubs.length !== 0 ? state.subs.WidgetSubs.activeSubs[0].ns : 0),
    description: "Active Subs (End)"
  }, {
    amount: state.subs.WidgetSubs.activeSubs.length !== 0 ? calculateGrowth(state.subs.WidgetSubs.activeSubs, state.filter.filters) : 0,
    type: "percentage",
    description: "Active Subs (Growth)",
    size: true
  }] : [],
  filters: {
    oc: state.filter.filters.oc,
    srvcId: state.filter.filters.service,
    startDate: state.filter.filters.startDate,
    endDate: state.filter.filters.endDate,
    tz: state.filter.filters.tz
  },
  colorScheme: ownProps.colorScheme,
  title: ownProps.title,
  onZoom: ownProps.onZoom,
  dataLoaded: state.subs.WidgetSubs && state.subs.WidgetSubs.loaded,
  filtersLoaded: state.filter.filters.oc
    && state.filter.filters.service
    && state.filter.filters.endDate
    && state.filter.filters.startDate,
  loaded: state.subs.WidgetSubs
    && state.subs.WidgetSubs.loaded
    && state.filter.filters.oc
    && state.filter.filters.service
    && state.filter.filters.endDate
    && state.filter.filters.startDate,
  shouldLoadData: !state.subs.WidgetSubs || (!state.subs.WidgetSubs.loaded && !state.subs.WidgetSubs.loading && !state.subs.WidgetSubs.error),
  drillOptions: ['Sub-Method', 'Language', 'Is-Prepaid'],
  drillData: [
    {
      label: 'Sub-Method',
      param: 'subMethod',
      onClick: ownProps.drillClick,
      widgetType: 'WidgetPieDrillSubs',
      widgetTitle: 'Subs Data - Sub-Method'
    },
    {
      label: 'Language',
      param: 'lang',
      onClick: ownProps.drillClick,
      widgetType: 'WidgetPieDrillSubs',
      widgetTitle: 'Subs Data - Language'
    },
    {
      label: 'Is-Prepaid',
      param: 'isPrepaid',
      onClick: ownProps.drillClick,
      widgetType: 'WidgetPieDrillSubs',
      widgetTitle: 'Subs Data - Is-Prepaid'
    }
  ],
})

//const mapDispatchToProps = { fetchData: getSubsData };
const mapDispatchToProps = (dispatch) => ({
  fetchData: (params, graphId) => {
    dispatch(getSubsData(params, graphId));
    dispatch(fetchActiveSubData(params, graphId));
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(WidgetLineGraph)



// WEBPACK FOOTER //
// ./src/components/ConnectedWidgets/WidgetSubsConnected.js